import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout-base" }
const _hoisted_2 = {
  id: "header",
  class: "fixed-top"
}
const _hoisted_3 = { id: "main" }

import MsgBoxInfo from '@/common/MsgBoxInfo.vue';
  import MsgBoxWarning from '@/common/MsgBoxWarning.vue';
  import MsgBoxOkCancel from '@/common/MsgBoxOkCancel.vue';

  // タイマートーストのインポート
  import TimerToast from '@/common/TimerToast.vue';

//#endregion


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


/********************************************************************************
 * メインモジュール
 *
 * @since 2023/02/20
 * @author 松本裕介
 *
 *********************************************************************************/

 //#region 共通モジュールのインポート

  // メッセージボックスのインポート
  
return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MsgBoxInfo),
    _createVNode(MsgBoxWarning),
    _createVNode(MsgBoxOkCancel),
    _createVNode(TimerToast),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createVNode(_component_router_view, { name: "header" })
      ]),
      _createElementVNode("main", _hoisted_3, [
        _createVNode(_component_router_view, { name: "main" })
      ])
    ])
  ], 64))
}
}

})